import axios from "axios";
import type { UnknownAction } from "@reduxjs/toolkit";
import { setLicenceValidity } from "../reducers/licence";
import { store } from "../ProviderApp";
import { getBackendUrl } from "@Utils";
import { createAxiosWrapper, PlatformAdapter, ApiResponse } from "./axiosShared";

const webAdapter: PlatformAdapter = {
  storage: {
    getItem: (key) => localStorage.getItem(key),
    removeItem: (key) => localStorage.removeItem(key),
  },
  navigation: {
    getCurrentPath: () => window.location.pathname,
    redirectToLogin: (params) => {
      const searchParams = new URLSearchParams();
      if (params?.redirectUrl) {
        searchParams.set("redirectUrl", encodeURIComponent(params.redirectUrl + window.location.search));
      }
      if (params?.errorMessage) {
        searchParams.set("errorMessage", encodeURIComponent(params.errorMessage));
      }
      window.location.href = `/?${searchParams.toString()}${window.location.hash}`;
    },
  },
  // The shared adapter declares `action` as `unknown` so mobile can plug its own store in. The only
  // things ever handed to it are this adapter's own two producers below — `{ type: "LOGOUT" }` and
  // `setLicenceValidity(false)` — dispatched by axiosShared.ts (the two `adapter.dispatch(
  // adapter.actions.…())` calls), so it is always an RTK action object. Fix: declare
  // `PlatformAdapter.dispatch`/`actions` in axiosShared.ts as `UnknownAction` and drop this.
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- see above: the two producers in `actions` are the only callers' input and both return RTK action objects
  dispatch: (action) => store.dispatch(action as UnknownAction),
  actions: {
    setLoggedOut: () => ({ type: "LOGOUT" }),
    setLicenceInvalid: () => setLicenceValidity(false),
  },
  excludedPathsFor401: ["/95789", "/signup", "/thank-you", "/pdfExport", "/"],
  getBackendUrl,
  isAuthenticated: () => Boolean(store.getState().checkIfAuthenticated?.data.status),
};

const { instance, typedAxios } = createAxiosWrapper(webAdapter, axios);

export type { ApiResponse };
export { typedAxios };
// Raw axios instance (interceptors already attached). Exposed so lifecycle-aware wrappers such as
// useAbortableApi can delegate to it while re-declaring the TypedAxiosInstance surface for callers.
export const axiosInstance = instance;
export const axiosWrapper = typedAxios;
export default typedAxios;
